const contact = () => import(/* webpackChunkName: "contact" */'@/page/contact/contact')
const contactList = () => import(/* webpackChunkName: "contact" */'@/page/contact/list')
const contactAdd = () => import(/* webpackChunkName: "contact" */'@/page/contact/add')
const contactDetail = () => import(/* webpackChunkName: "contact" */'@/page/contact/detail')
const contactGroup = () => import(/* webpackChunkName: "contact" */'@/page/contact/group')

const contactRouter = {
    path: 'contact',
    name: 'contact',
    component: contact,
    children: [{
        path: 'all',
        name: 'allContact',
        component: contactList
    }, {
        path: 'recent',
        name: 'recentContact',
        component: contactList
    }, {
        path: 'important',
        name: 'importantContact',
        component: contactList
    }, {
        path: 'custom/:id',
        name: 'customContact',
        component: contactList
    }, {
        path: 'add',
        name: 'addContact',
        component: contactAdd
    }, {
        path: 'group/:id?',
        name: 'addGroup',
        component: contactGroup
    }, {
        path: 'edit/:id',
        name: 'editContact',
        component: contactAdd
    }, {
        path: 'detail/:id',
        name: 'detailContact',
        component: contactDetail
    }, {
        path: '/contact*',
        redirect: 'all'
    }]
}

export default contactRouter




// WEBPACK FOOTER //
// ./src/router/contact.js